<template>
  <nav id="top-navbar">
    <div class="main-container">
      <div class="row">
        <div class="col-auto">
          <ul class="tn-list">
            <!-- <li class="tn-list__item">
              <a class="tn-list__btn" data-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                <i class="icon-world"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-left dropdown-menu-animated topbar-dropdown-menu">
                <a v-for="language in languages" :key="language.key" @click="setSelectedLanguage(language)"
                  class="dropdown-item notify-item">
                  <span class="align-middle">{{ language.value }}</span>
                </a>
              </div>
            </li> -->
            
            <li class="tn-list__item">
              <a class="tn-list__btn" data-toggle="dropdown" href="" role="button" aria-haspopup="false" aria-expanded="false">
                <span v-if="filter" class="category-title">{{ filter.name[selectedLanguage.key ] }}</span>
                <span v-else class="category-title">{{ t('message["Select"]', 'Select') }}</span>
                <i class="icon-angle-down category-title" style="font-size: 8px; margin-left: 5px; margin-bottom: 5px"></i>
              </a>
              <div class="dropdown-menu dropdown-menu-center  dropdown-menu-animated topbar-dropdown-menu">
                <a class="dropdown-item notify-item" @click="setFilterProducts(null)">
                  <span class="align-middle">{{ t('message["Select"]', 'Select') }}</span>
                </a>
                <a v-for="category in categories" :key="category.id" @click="setFilterProducts(category)"
                  class="dropdown-item notify-item">
                  <span class="align-middle">{{ category.name[selectedLanguage.key] }}</span>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="col-auto ml-auto">
          <button v-if="clientSettings.call_a_waiter && isTable" @click="callAWaiterHandler()" id="call-waiter-button">call waitress</button>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  import language from '../mixins/translate'
  import {
    mapState,
    mapActions
  } from 'vuex'
  import {
    callAWaiter
  } from '../services/client'

  export default {
    mixins: [language],
    computed: {
      ...mapState('settings', ['selectedLanguage', 'availableLanguages', 'clientSettings', 'isTable', 'tableNumber']),
      ...mapState('products', ['categories', 'filter', 'products']),
      languages() {
        return Object.keys(this.availableLanguages)
          .map(key => ({
            key,
            value: this.availableLanguages[key]
          }))
      }
    },
    methods: {
      ...mapActions('settings', ['setSelectedLanguage']),
      ...mapActions('products', ['setFilter']),
      async callAWaiterHandler() {
        const response = await callAWaiter(this.tableNumber)
        this.$notify({
          group: 'app',
          text: response.message
        });
      },
      setFilterProducts(value) {
        if (value) {
          value.products = this.products.filter(product => {
              const itemCategoriesIds = product.categories.map(cat => cat.id);
              return !!itemCategoriesIds.includes(value.id);
          });
      }
      this.setFilter(value)
      }
    }, 
  }
</script>
